import React, { useState, useEffect } from 'react';
import { Accordion, Card, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import Select from 'react-select';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { isEmpty, cloneDeep } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { SystemMasterSelect } from '../../Components/helper';
import Loader from '../../Components/Utility/Loader/Loader';
import BtnAdd from '../../Components/Utility/FilterAction/BtnAdd';
import * as action from './Store/SystemMasters.action';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';
import CustomTooltip from '../../Components/Tooltip/CustomTooltip';

const PCTypeOptions = [
  { name: 'Tier 1', value: 'Tier1', type: 4 },
  { name: 'Tier 2', value: 'Tier2', type: 4 },
  { name: 'Tier 3', value: 'Tier3', type: 4 },
  { name: 'Tier 4', value: 'Tier4', type: 4 },
];

const tempObj = {
  name: null,
  isEmpty: false,
  isNew: true,
  isActive: true,
  hasLength: false,
  _id: '',
  aliasName: '',
};

function ProductComponentTypeMaster() {
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const supplierType = 'supplier-type';
  const {
    SystemMastersDetails,
    UserDetails,
    Users: { logInRights },
  } = reducer;
  const { pcTypeAdminList } = SystemMastersDetails;
  const { userInfo } = UserDetails;

  const { t } = useTranslation('common');
  const loggedInUserId = userInfo.userId;

  const [isLoadingPCTM, setIsLoadingPCTM] = useState(false);
  const [showPcType, setShowPcType] = useState(false);
  const [isPCTypeUnique, setIsPCTypeUnique] = useState(true);
  const [buttonDownPcType, setButtonDownPcType] = useState(true);
  const [pctmBtnDisable, setPctmBtnDisable] = useState(false);
  const [addingPCType, setAddingPCType] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [isPCTM, setIsPCTM] = useState(false);
  const [pCTypesData, setPCTypesData] = useState([]);
  const [isUniqPCTypeId, setIsUniqPCTypeId] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [activeInactiveID, setActiveInactiveID] = useState('');
  const [scrollEl, setScrollEl] = useState();
  const [PCTypes, setPCTypes] = useState({
    name: 'Tier 1',
    value: 'Tier1',
    type: 4,
  });

  const { CheckActionPermission } = useComponent();
  const [userRights, setUserRights] = useState({});
  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);
  const MasterAddEditAccess = CheckActionPermission(userRights, 'masters', 'prodCompTypes', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(userRights, 'masters', 'prodCompTypes', 'delete');

  useEffect(() => {
    if (scrollEl) {
      scrollEl.scrollTop = 1000;
    }
  }, [scrollEl]);

  useEffect(() => {
    const selectedTier = PCTypes?.value;
    const shouldStrictFilterByTier = selectedTier === 'Tier3' || selectedTier === 'Tier4';
    const filteredPcTypeList = shouldStrictFilterByTier ? (pcTypeAdminList || [])?.filter((ele) => ele?.tier === selectedTier) : pcTypeAdminList;

    setPCTypesData(filteredPcTypeList);
    if (addingPCType) {
      setPCTypesData([
        ...(filteredPcTypeList || []),
        {
          name: null,
          isEmpty: false,
          isNew: true,
          isActive: true,
          _id: '',
          aliasName: '',
        },
      ]);
    }
  }, [pcTypeAdminList, addingPCType, PCTypes?.value]);

  useEffect(() => {
    showPcType && Object?.keys(PCTypes)?.length !== 0 && pcTypeCalled();
  }, [PCTypes]);

  const pcTypeCalled = async () => {
    const pcTypeParams = {
      tier: PCTypes?.value,
    };
    await dispatch(action.getPCTypesAdminDetails(pcTypeParams, true));
  };

  const callApi = async () => {
    setButtonDownPcType(!buttonDownPcType);
    setIsLoadingPCTM(true);
    buttonDownPcType ? setShowPcType(true) : setShowPcType(false);
    buttonDownPcType && (await pcTypeCalled());
    setIsLoadingPCTM(false);
  };

  const handleChanged = (event, i) => {
    const pctd = [...pCTypesData];
    setIsPCTypeUnique(true);
    setIsUniqPCTypeId([]);
    if (event.target.name === 'aliasName') {
      pctd[i] = {
        ...pctd[i],
        aliasName: event.target.value,
      };
      setPCTypesData(pctd);
      return;
    }
    pctd[i] = {
      ...pctd[i],
      name: event.target.value,
      isEmpty: event.target.value === '',
    };
    const arr = [];
    const arrIndex = [];
    pctd.forEach((ele, ind) => {
      pctd.forEach((objs, index) => {
        if (ele.name === objs.name && ind !== index) {
          arr.push(ele);
          arrIndex.push(index);
        }
      });
    });
    if (!isEmpty(arr)) {
      const arrs = [...arrIndex];
      const removeArss = Math.min(...arrs);
      const newArr = arrIndex.filter((ele) => ele !== removeArss);
      setIsUniqPCTypeId([...newArr]);
    }
    setIsPCTypeUnique(isEmpty(arr));
    let isDisableLength = false;
    pctd.forEach((lensElement) => {
      if (isEmpty(lensElement?.name?.trim())) {
        isDisableLength = true;
      }
    });
    setPctmBtnDisable(isDisableLength);
    setPCTypesData(pctd);
  };

  const handleDelete = (id) => {
    if (typeof id === 'number' || id === '') {
      pCTypesData.splice(id, 1);
      pCTypesData.forEach((pctdElement) => {
        if (isEmpty(pctdElement?.name?.trim()) && pctdElement.isNew) {
          setPctmBtnDisable(true);
        } else {
          setPctmBtnDisable(false);
        }
      });
      setIsPCTypeUnique(true);
      setIsUniqPCTypeId([]);
      setPCTypesData([...pCTypesData]);
    } else {
      setDeleteId(id);
      setShowConfirmation(true);
    }
  };

  const activeInactiveClicked = (id) => {
    setShowConfirmationAD(true);
    setActiveInactiveID(id);
  };

  useEffect(() => {
    const array = [];
    pCTypesData.forEach((ele, index) => {
      pCTypesData.forEach((obj, places) => {
        if (index !== places && ele?.name === obj?.name) {
          array.push(ele);
        }
      });
    });
    if (isEmpty(array)) {
      setIsPCTypeUnique(isEmpty(array));
      setIsUniqPCTypeId([]);
    }
  }, [pCTypesData]);

  const deleteConfirmed = async () => {
    setIsLoadingConf(true);
    const pctypeParams = {
      loggedInUserId,
      supplierTypeId: deleteId,
      title: supplierType,
    };
    await dispatch(action.deleteFromSystemMasters(pctypeParams, t));
    setIsLoadingConf(false);
    setShowConfirmation(false);
    setPCTypesData([...pcTypeAdminList]);
    await pcTypeCalled();
  };

  const activeInactiveConfirmed = async () => {
    setIsLoadingConf(true);
    let pct = {};
    const cloneData = cloneDeep(pCTypesData)?.map((ele) => {
      if (ele._id === activeInactiveID) {
        ele.isActive = !ele.isActive;
        const data = {
          ...ele,
          loggedInUserId,
          title: supplierType,
        };
        pct = data;
      }
      return ele;
    });
    const res = await dispatch(action.setActiveInactive(pct, t));
    if (res) {
      setPCTypesData([...cloneData]);
    }
    setIsLoadingConf(false);
    setShowConfirmationAD(false);
  };

  const addPctm = () => {
    if (!showPcType) {
      callApi();
      setAddingPCType(true);
      setButtonDownPcType(!buttonDownPcType);
      setIsLoadingPCTM(true);
      buttonDownPcType ? setShowPcType(true) : setShowPcType(false);
      setIsLoadingPCTM(false);
    } else {
      setAddingPCType(false);
      if (!isEmpty(pCTypesData)) {
        setPCTypesData([...pCTypesData, tempObj]);
      } else {
        setPCTypesData([tempObj]);
      }
    }
  };

  const btnCall = () => {
    if (buttonDownPcType === false) {
      return <i className="icon-new-up" />;
    }
    return <i className="icon-new-down" />;
  };

  const renderTooltipOpenClosePcType = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {!buttonDownPcType ? t('PRODUCT_COMPONENT_TYPE.CLOSE') : t('PRODUCT_COMPONENT_TYPE.OPEN')}
    </Tooltip>
  );

  const renderTooltipActiveInactive = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('PRODUCT_COMPONENT_TYPE.ACTIVE_INACTIVE')}
    </Tooltip>
  );

  const renderTooltipDelete = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('PRODUCT_COMPONENT_TYPE.DELETE')}
    </Tooltip>
  );

  const savePctm = async () => {
    setIsPCTM(true);
    if (!isEmpty(pCTypesData)) {
      const emptyField = await pCTypesData.filter((pctitem) => pctitem.name === null || pctitem.name === '');
      if (isEmpty(emptyField)) {
        const data = pCTypesData.map((pctobj) => {
          return {
            ...pctobj,
            name: pctobj?.name?.trim(),
            tier: PCTypes.value,
            aliasName: pctobj?.aliasName ? pctobj.aliasName.trim() : '',
          };
        });
        const pctmParms = {
          names: JSON.stringify(data),
          title: supplierType,
        };
        setAddingPCType(false);
        await dispatch(action.saveToSystemMaster(pctmParms, t));
        await pcTypeCalled();
        // post API
      } else {
        const newState = pCTypesData.map((pCTobj) => (pCTobj?.isEmpty === false && pCTobj.name === null ? { ...pCTobj, isEmpty: true } : pCTobj));
        setPCTypesData(newState);
      }
    }
    setIsPCTM(false);
  };

  const savesPctm = () => {
    return isPCTM ? (
      <Spinner animation="border" />
    ) : (
      <>
        <span className="icon-Save c-button-align f-20 mr-2" /> {t('PRODUCT_COMPONENT_TYPE.SAVE')}
      </>
    );
  };

  const handleDropdownChange = (value, fromName) => {
    if (fromName === 'PCType') {
      setPCTypes(value);
    }
  };
  return (
    <>
      <Accordion className="mb-4 master-accordian">
        <Card>
          <Card.Header>
            <div className="title-container">
              <p>{t('PRODUCT_COMPONENT_TYPE.TITLE')}</p>
            </div>
            <div className={!MasterAddEditAccess ? 'action-title-btns single-btn' : 'action-title-btns'}>
              <BtnAdd onBtnClick={addPctm} forDisable={pctmBtnDisable || !isPCTypeUnique} addEditAccess={MasterAddEditAccess} />
              <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipOpenClosePcType}>
                <button onClick={() => callApi()}>{btnCall()}</button>
              </OverlayTrigger>
            </div>
          </Card.Header>
          {showPcType &&
            (isLoadingPCTM ? (
              <Loader />
            ) : (
              <Card.Body>
                <div className="select-container">
                  <Select
                    options={PCTypeOptions}
                    placeholder={t('PRODUCT_COMPONENT_TYPE.SELECT_PLACEHOLDER')}
                    getOptionLabel={(option) => `${option.name}`}
                    getOptionValue={(option) => `${option.value}`}
                    name="PCType"
                    value={Object.keys(PCTypes).length > 0 ? PCTypes : null}
                    styles={SystemMasterSelect}
                    onChange={(e) => handleDropdownChange(e, 'PCType')}
                  />
                </div>
                <PerfectScrollbar
                  containerRef={(ref) => {
                    setScrollEl(ref);
                  }}
                >
                  <ul>
                    {Object.keys(PCTypes).length !== 0 &&
                      !isEmpty(pCTypesData) &&
                      pCTypesData.map((pct, pctindex) => {
                        return (
                          <li key={pct?._id}>
                            {PCTypes.value === 'Tier1' && (
                              <input
                                name="aliasName"
                                value={pct?.aliasName ?? ''}
                                maxLength={5}
                                onChange={(e) => handleChanged(e, pctindex)}
                                className="w-50px mr-2"
                              />
                            )}
                            <div className="input-container">
                              <input
                                name="pctype"
                                autoFocus={!pct._id}
                                value={pct.name ? pct.name : ''}
                                placeholder={t('PRODUCT_COMPONENT_TYPE.INPUT_PLACEHOLDER')}
                                type="text"
                                onChange={(e) => handleChanged(e, pctindex)}
                              />
                              {!isEmpty(isUniqPCTypeId) && isUniqPCTypeId.includes(pctindex) && (
                                <label htmlFor="exist" className="text-danger m-0 p-1">
                                  {t('PRODUCT_COMPONENT_TYPE.ENTRY_EXISTS')}
                                </label>
                              )}
                              {pct.isEmpty && (pct.name === null || pct.name === '') && (
                                <label htmlFor="type" className="text-danger m-0 p-1">
                                  {t('PRODUCT_COMPONENT_TYPE.TYPE_REQUIRED')}
                                </label>
                              )}
                              {pct.isNew && !isEmpty(pct.name) && isEmpty(pct?.name?.trim()) && (
                                <label htmlFor="name" className="text-danger m-0 p-1">
                                  {t('PRODUCT_COMPONENT_TYPE.ENTRY_INVALID')}
                                </label>
                              )}
                            </div>
                            <div className="input-action">
                              {pct._id !== '' && MasterAddEditAccess && (
                                <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipActiveInactive}>
                                  <button aria-label="active" type="button" onClick={() => activeInactiveClicked(pct._id)} id={pct._id}>
                                    <span className={pct.isActive ? 'icon-active' : 'icon-inactive'} />
                                  </button>
                                </OverlayTrigger>
                              )}
                              {MasterDeleteAccess && (
                                <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={renderTooltipDelete}>
                                  <button aria-label="delete" type="button" onClick={() => handleDelete(pct._id ? pct._id : pctindex)}>
                                    <span className="icon-delete mt-3 f-20" />
                                  </button>
                                </OverlayTrigger>
                              )}
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                </PerfectScrollbar>
                <div className="section-save">
                  {MasterAddEditAccess && (
                    <CustomTooltip tooltipText={t('common:COMMON_LABEL.SAVE')}>
                      <button
                        aria-label="Save"
                        type="button"
                        className="btn btn-page-filter btn-white"
                        onClick={savePctm}
                        disabled={pctmBtnDisable || !isPCTypeUnique}
                      >
                        {savesPctm()}
                      </button>
                    </CustomTooltip>
                  )}
                </div>
              </Card.Body>
            ))}
        </Card>
      </Accordion>
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={() => deleteConfirmed()}
          title={t('PRODUCT_COMPONENT_TYPE.DELETE_MESSAGE')}
          message={t('PRODUCT_COMPONENT_TYPE.MESSAGE')}
          toggle={() => {
            setShowConfirmation(!showConfirmation);
          }}
          loading={isLoadingConf}
        />
      )}
      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={() => activeInactiveConfirmed()}
          title={t('PRODUCT_COMPONENT_TYPE.ACTIVATE_DEACTIVATE')}
          message={t('PRODUCT_COMPONENT_TYPE.DEACTIVATE_MESSAGE')}
          toggle={() => {
            setShowConfirmationAD(!showConfirmationAD);
          }}
          loading={isLoadingConf}
        />
      )}
    </>
  );
}
export default ProductComponentTypeMaster;
